import React, { Component } from 'react';
import palette from '../../../theme/palette';

export default class ImageIconBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            src: props.src,
            style: props.style,
            size: props.size,
            padding: props.padding,
        }
    }

    render() {
        return (
            <div style={this.state.style}>
                <img src={this.state.src} style={{ width: this.state.size ?? '30px', height: this.state.size ?? '30px', backgroundColor: palette.primary.main, padding: this.state.padding ?? '6px', borderRadius: '3px' }}></img>
            </div>
        );
    }
}
